var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * h5 裁切页面模版
 */
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState, } from 'react';
import H5CommonComponent from '@tencent/h5-common-component';
import ImageCropper from '../../ImageCropper';
import Modal from '../../Modal';
import style from './index.module.scss';
import { ERROR_CODE_MAPPING } from '../../../../components/H5ChristmasIndexPage/h5-config';
import { mergeCssStyles } from '../../../utils';
import { reportBtnClick, reportError } from '../../../utils/beacon';
const DEFAULT_FEEDBACK_MSG = '当前体验人数较多, 请稍后再试吧~';
const DEFAULT_CONFIRM_MSG = '好的';
const CropPage = ({ originImage, maskImgUrl, actionArea, topArea, changePictureImgUrl, submitBtnImgUrl, loadingImgUrl, onSubmitResult, handleBackendLogic, cropAreaContent, styleCustom, ratio, viewModeInfo, autoCropArea, initialScale, isOriginPickerInWechat, logoUrl, customLoadingContent, fixedCropInfo, isNeedFixedCrop, isNeedBackground, minContainerWidth, autoCropLocation, children, handelReselectAction, }, ref) => {
    const cropEl = useRef(null);
    const [cropImageData, setCropImage] = useState(originImage);
    const [feedbackModalVisible, setFeedbackModalVisible] = useState(false);
    const [confirmCallback, setConfirmCallback] = useState(null);
    const [feedbackMsg, setFeedbackMsg] = useState(DEFAULT_FEEDBACK_MSG);
    const [confirmMsg] = useState(DEFAULT_CONFIRM_MSG);
    // loading弹窗
    const [loadingModalVisible, setLoadingModalVisible] = useState(false);
    const mergeStyle = styleCustom ? mergeCssStyles(style, styleCustom) : style;
    useEffect(() => {
        setCropImage(originImage);
    }, [originImage]);
    useImperativeHandle(ref, () => ({
        getCropedImage: () => {
            return cropEl.current.getImageData();
        },
        reselectImage: () => {
            handleChangePic();
        },
        submitImage: handleSubmit,
    }));
    const modalContent = () => (React.createElement("div", { className: mergeStyle['feedback-modal'] },
        React.createElement("div", { className: mergeStyle['feedback-modal-title'] }, feedbackMsg),
        React.createElement("div", { className: mergeStyle['feedback-modal-action-btn'], onClick: () => {
                setFeedbackModalVisible(false);
            } }, confirmMsg)));
    const loadingContent = () => {
        return (customLoadingContent || (React.createElement("div", { className: mergeStyle['loading-modal'] },
            React.createElement("img", { src: loadingImgUrl, alt: "" }),
            React.createElement("div", null, "\u7ED3\u679C\u751F\u6210\u4E2D..."))));
    };
    const handleSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const imageData = cropEl.current.getImageData();
        // 存在裁图组件尚未初始化完成就提交的情况
        if (!imageData)
            return;
        // 默认数据处理逻辑
        if (!handleBackendLogic) {
            onSubmitResult(imageData);
        }
        else {
            // 处理数据
            setLoadingModalVisible(true);
            try {
                const response = yield handleBackendLogic(imageData);
                const code = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.code;
                if (code !== 0) {
                    setLoadingModalVisible(false);
                    const errMsg = ERROR_CODE_MAPPING[code]
                        ? ERROR_CODE_MAPPING[code].msg
                        : '活动太火爆了，请稍后再试';
                    reportError({ errCode: code, errMsg });
                    setFeedbackMsg(errMsg);
                    setFeedbackModalVisible(true);
                    return;
                }
                onSubmitResult(response);
            }
            catch (err) {
                reportError({ errMsg: err.message });
                setFeedbackMsg(err.message);
                setFeedbackModalVisible(true);
                setConfirmCallback(null);
            }
        }
        setLoadingModalVisible(false);
    });
    const handleChangePic = () => {
        const imagePickerInstance = new H5CommonComponent.ImagePickerEnhance(true, 0, isOriginPickerInWechat);
        imagePickerInstance.chooseImage((imgData, sourceType) => {
            if (typeof sourceType !== 'undefined') {
                reportBtnClick(sourceType === 0 ? 'crop#pick-album' : 'crop#take-photo');
            }
            if (handelReselectAction) {
                handelReselectAction(imgData);
                return;
            }
            setCropImage(imgData);
        });
    };
    return (React.createElement("div", { className: mergeStyle['crop-page'] },
        topArea,
        React.createElement("div", { className: mergeStyle['crop-panel'] },
            React.createElement(ImageCropper, { imgBase64: cropImageData, maskImgUrl: maskImgUrl, resultImgSize: 720, ref: cropEl, ratio: ratio, viewMode: viewModeInfo, autoCropArea: autoCropArea, initialScale: initialScale, fixedCropInfo: fixedCropInfo, isNeedFixedCrop: isNeedFixedCrop, isNeedBackground: isNeedBackground, minContainerWidth: minContainerWidth, autoCropLocation: autoCropLocation }),
            cropAreaContent),
        children,
        React.createElement("div", { className: mergeStyle['action-panel'] }, actionArea ? (actionArea) : (React.createElement(React.Fragment, null,
            React.createElement("img", { "data-btn-id": "crop#change-image", className: style['change-pic'], src: changePictureImgUrl, alt: "", onClick: handleChangePic }),
            React.createElement("img", { "data-btn-id": "crop#submit", src: submitBtnImgUrl, alt: "", onClick: handleSubmit, className: mergeStyle['action-submit'] })))),
        React.createElement(Modal, { content: modalContent(), visible: feedbackModalVisible, hideModal: () => {
                setFeedbackModalVisible(false);
            } }),
        React.createElement(Modal, { content: loadingContent(), visible: loadingModalVisible, isClosedByClick: false, hideModal: () => {
                setLoadingModalVisible(false);
            } }),
        logoUrl ? (React.createElement("div", { className: style.logo },
            React.createElement("img", { src: logoUrl, alt: "alt" }))) : null));
};
export default forwardRef(CropPage);
